import type { ShareSecurity, ShareSecurityLevel } from '@carboncopyco/types';
import {
  Dropdown,
  DropdownItem,
  InputTagsField,
  InputTextField,
} from '@carboncopyco/ui';
import { Field, type FieldProps, useFormikContext } from 'formik';
import { SecurityItem } from './SecurityItem';
import type { SecurityItem as SecurityItemType } from './consts';

export function SecurityField<S extends { security: ShareSecurity }>({
  onSecurityLevelChange,
  items,
}: {
  onSecurityLevelChange?: (level: ShareSecurityLevel, values: S) => S;
  items: SecurityItemType[];
}) {
  const { values } = useFormikContext<S>();

  return (
    <div className="flex flex-col">
      {values.security.level === 'restricted' ? (
        <div className="pb-6">
          <InputTagsField
            required
            label="Emails"
            name="security.emails"
            initialValue={values?.security?.emails || []}
            placeholder="Type emails"
            className="w-full p-0"
            maxHeight={100}
          />
        </div>
      ) : null}
      {values.security.level === 'email_domain' ? (
        <InputTextField
          required
          label="Domain"
          name="security.emailDomain"
          placeholder="demostack.com"
          className="w-full p-0"
          inputSize="lg"
        />
      ) : null}
      <Dropdown
        width="100%"
        triggerElement={
          <SecurityItem
            variant="trigger"
            accessLevel={values.security.level}
          />
        }
      >
        <div
          role="group"
          className="w-[554px] p-5"
        >
          {items.map((item) => {
            const { id, disabled } = item;
            return (
              <Field
                name="security.level"
                value={id}
                key={id}
              >
                {({ form }: FieldProps) => {
                  return (
                    <DropdownItem
                      onClick={() => {
                        onSecurityLevelChange
                          ? form.setValues(
                              onSecurityLevelChange(id, form.values)
                            )
                          : form.setFieldValue('security', id);
                      }}
                      disabled={disabled}
                    >
                      <SecurityItem
                        isSelected={values.security.level === id}
                        accessLevel={id}
                        disabled={disabled}
                      />
                    </DropdownItem>
                  );
                }}
              </Field>
            );
          })}
        </div>
      </Dropdown>
    </div>
  );
}
